import React from "react";
import { Flex, Card } from "antd";
import {
  EnvironmentOutlined,
  PhoneOutlined,
  MailOutlined,
} from "@ant-design/icons";
import Header from "../components/Header/Header";
import MyText from "../../components/UI/Text/MyText";
import Footer from "../components/Footer/Footer";

const cardStyle = {
  width: 300,
  minHeight: 150,
  borderRadius: 16,
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  background: "#f9fbff",
  flexShrink: 0,
};

const bodyStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 16,
  padding: 24,
  textAlign: "center",
};

const SupportPage = () => {
  return (
    <Flex
      style={{ width: "100%", position: "relative" }}
      vertical
      align="center"
      justify="flex-start"
    >
      <Header />
      <Flex
        style={{
          width: "100%",
          paddingTop: 250,
          paddingBottom: 50,
        }}
        vertical
        align="center"
        justify="flex-start"
      >
        <Flex
          style={{ width: "100%", maxWidth: 1440 }}
          vertical
          gap={35}
          align="center"
        >
          <MyText style={{ fontSize: "2rem", fontWeight: "bold" }}>
            Холбоо барих
          </MyText>

          {/* Card-уудыг хөндлөн байрлуулсан Flex */}
          <Flex
            style={{
              width: "100%",
              maxWidth: 1200,
              gap: 24,
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <Card style={cardStyle} bodyStyle={bodyStyle}>
              <EnvironmentOutlined style={{ fontSize: 32, color: "#1890ff" }} />
              <MyText>
                УБ хот, СБД 1-р хороо, UBH төв <br /> 14 давхар, 1413 тоот
              </MyText>
            </Card>

            <Card style={cardStyle} bodyStyle={bodyStyle}>
              <PhoneOutlined style={{ fontSize: 32, color: "#1890ff" }} />
              <MyText>+976 7707-9295</MyText>
            </Card>

            <Card style={cardStyle} bodyStyle={bodyStyle}>
              <MailOutlined style={{ fontSize: 32, color: "#1890ff" }} />
              <MyText>gf@fav-service.de, khugjiltuv@gmail.com</MyText>
            </Card>
          </Flex>
        </Flex>
      </Flex>
      <Footer />
    </Flex>
  );
};

export default SupportPage;
